import script from "./RagDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./RagDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./RagDashboardView.vue?vue&type=style&index=0&id=0715c5bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0715c5bc"]])

export default __exports__